/* Fixed-design frame pages (sections/vinyl-frame-page.liquid): a frame for a 12" record, a 7" single, and later
   CDs, coins and so on. Standard products: one variant per moulding, each with its own price (set in the back office
   like any standard frame). The customer picks the variant (moulding) and the inner mount colour; the glazing and the
   white outer mount are fixed. The size and cut-out come from the back office's preset (for the preview and the
   workshop); the preview is drawn by assets/frame-draw.js. The cart line is the variant, with the inner mount colour,
   the cut-out and the glass size as line-item properties for the workshop. */
(function () {
  'use strict';

  var root = document.querySelector('[data-vf]');
  if (!root || !window.SkelfFrameDraw) return;
  var D = window.SkelfFrameDraw;
  var API = (root.getAttribute('data-api') || '').replace(/\/+$/, '');
  var PRESET = root.getAttribute('data-preset');
  var PHONE = root.getAttribute('data-phone') || '01937 530 623';
  var GLASS = root.getAttribute('data-glass') || 'clear'; // how the fixed glazing looks: 'clear' (glass) or 'styrene'
  var T = function (event, props) { try { (window.skelfTrackQueued || window.skelfTrack || function () {})(event, Object.assign({ item: PRESET }, props || {})); } catch (e) { /* never break the page */ } };
  var $ = function (sel, el) { return (el || root).querySelector(sel); };
  var $$ = function (sel, el) { return Array.prototype.slice.call((el || root).querySelectorAll(sel)); };
  var esc = function (v) { return String(v == null ? '' : v).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
  var money = function (v) { return '£' + (Math.round(v * 100) / 100).toFixed(2).replace(/\.00$/, ''); };
  var norm = function (t) { return String(t || '').replace(/\s+/g, ' ').trim().toLowerCase(); };

  // The product's variants (one per moulding), from the page
  var variants = [];
  try { variants = JSON.parse(($('[data-vf-variants]') || {}).textContent || '[]'); } catch (e) { variants = []; }
  var selectedId = Number(root.getAttribute('data-selected')) || (variants[0] && variants[0].id);

  var cat = null, preset = null, outerMount = null;
  var state = { variantId: selectedId, innerId: null, art: null };
  var view = 'frame';

  var variant = function () { return variants.find(function (v) { return v.id === state.variantId; }) || variants[0]; };
  // A variant's moulding in the catalogue (for its photo and width): matched by name
  var mouldingFor = function (v) { return v && cat && cat.mouldings.find(function (m) { return norm(m.name) === norm(v.title); }); };
  var mountById = function (id) { return cat && cat.mounts.find(function (m) { return m.id === id; }); };
  var mountByName = function (n) { return cat && cat.mounts.find(function (m) { return norm(m.name) === norm(n); }); };

  /* ---------- Preview ---------- */
  var canvas = $('.mb-canvas'), wrap = $('.mb-canvas-wrap');
  function spec() {
    var m = mouldingFor(variant());
    return {
      preset: preset, fw: (m && m.widthMm) || 20, moulding: m ? D.image(m.imageLength) : null,
      outerMount: outerMount, innerMount: mountById(state.innerId), glass: GLASS,
      art: state.art, labelColour: '#c8372d'
    };
  }
  var raf = null;
  function scheduleDraw() { if (!raf) raf = requestAnimationFrame(function () { raf = null; paint(); }); }
  function paint() {
    if (!preset) return;
    var dpr = Math.min(window.devicePixelRatio || 1, 2.5);
    var cw = wrap.clientWidth, ch = wrap.clientHeight;
    if (canvas.width !== Math.round(cw * dpr) || canvas.height !== Math.round(ch * dpr)) { canvas.width = Math.round(cw * dpr); canvas.height = Math.round(ch * dpr); }
    var ctx = canvas.getContext('2d');
    if (ctx.reset) ctx.reset(); else canvas.width = canvas.width;
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    var sp = spec(), size = D.outerSize(preset, sp.fw), scale, ox, oy;
    if (view === 'wall') {
      scale = Math.min(ch / 2700, cw / 3400);
      var floor = ch - 26;
      var wallG = ctx.createLinearGradient(0, 0, 0, floor);
      wallG.addColorStop(0, '#ece7df'); wallG.addColorStop(1, '#e2dbcf');
      ctx.fillStyle = wallG; ctx.fillRect(0, 0, cw, floor);
      ctx.fillStyle = '#cdbfa9'; ctx.fillRect(0, floor, cw, ch - floor);
      ctx.fillStyle = '#f4f0e9'; ctx.fillRect(0, floor - 90 * scale, cw, 90 * scale);
      D.sofa(ctx, (cw - 2000 * scale) / 2, floor, scale);
      ox = (cw - size.w * scale) / 2;
      oy = Math.max(16, floor - (850 + 250) * scale - size.h * scale);
    } else {
      ctx.fillStyle = '#efebe4'; ctx.fillRect(0, 0, cw, ch);
      var pad = Math.max(44, Math.min(cw, ch) * 0.1); // room for the sizes beside the frame
      scale = Math.min((cw - 2 * pad) / size.w, (ch - 2 * pad) / size.h);
      ox = (cw - size.w * scale) / 2; oy = (ch - size.h * scale) / 2;
    }
    ctx.save(); ctx.translate(ox, oy); ctx.scale(scale, scale);
    D.drawPreset(ctx, sp, { dpr: dpr, scale: scale });
    ctx.restore();
    $('[data-wall-note]').hidden = view !== 'wall';
    placeDims(view === 'frame' ? { x: ox, y: oy, w: size.w * scale, h: size.h * scale } : null, size, sp.fw);
  }
  /* The outside size beside the frame, and the sizes underneath (cm and inches) */
  var cmIn = function (mm) { return (Math.round(mm / 10 * 10) / 10) + 'cm'; };
  var inch = function (mm) { return (Math.round(mm / 25.4 * 4) / 4) + '″'; };
  function placeDims(box, size, fw) {
    var dw = $('.mb-dim--w'), dh = $('.mb-dim--h');
    $('[data-fact="outside"]').textContent = '≈ ' + cmIn(size.w) + ' × ' + cmIn(size.h) + ' (' + inch(size.w) + ' × ' + inch(size.h) + ')';
    $('[data-fact="glass"]').textContent = cmIn(preset.glassW) + ' × ' + cmIn(preset.glassH) + ' (' + inch(preset.glassW) + ' × ' + inch(preset.glassH) + ')';
    $('[data-fact="fw"]').textContent = Math.round(fw) + 'mm';
    if (!box) { dw.hidden = dh.hidden = true; return; }
    dw.hidden = dh.hidden = false;
    dw.style.left = box.x + 'px'; dw.style.top = (box.y + box.h + 12) + 'px'; dw.style.width = box.w + 'px';
    dh.style.left = (box.x + box.w + 12) + 'px'; dh.style.top = box.y + 'px'; dh.style.height = box.h + 'px';
    dw.querySelector('span').textContent = '≈ ' + cmIn(size.w);
    dh.querySelector('span').textContent = '≈ ' + cmIn(size.h);
  }
  D.onImage(function () { scheduleDraw(); drawThumbs(); });
  window.addEventListener('resize', scheduleDraw);
  $$('[data-view]').forEach(function (b) {
    b.addEventListener('click', function () {
      view = b.getAttribute('data-view');
      $$('[data-view]').forEach(function (x) { x.setAttribute('aria-selected', x === b ? 'true' : 'false'); });
      if (view === 'wall') T('mtm_wall_view');
      scheduleDraw();
    });
  });

  /* ---------- Options: the frame (variant) and the inner mount colour ---------- */
  var FILTERS = [
    { key: 'all', label: 'All' },
    { key: 'black', label: 'Black', re: /black|ebony|jet/i },
    { key: 'white', label: 'White', re: /white|ivory|cream/i },
    { key: 'wood', label: 'Wood', re: /oak|walnut|wood|wenge|natural|pine|ash|beech|veneer/i },
    { key: 'grey', label: 'Grey', re: /grey|gray|pewter|gunmetal/i },
    { key: 'gold', label: 'Gold', re: /gold|brass|bronze/i },
    { key: 'silver', label: 'Silver', re: /silver|chrome|aluminium/i }
  ];
  var filter = 'all';
  var thumbs = [];
  var THUMB = { glassW: 300, glassH: 200, revealMm: 0, windows: [{ kind: 'rect', x: 60, y: 40, w: 180, h: 120 }], sample: { sleeveMm: 0, recordMm: 0, labelMm: 0 } };
  function drawThumbs() {
    if (!cat) return;
    thumbs = thumbs.filter(function (c) {
      var m = mouldingFor(variants.find(function (v) { return String(v.id) === c.getAttribute('data-id'); }));
      if (!m) return false; // no photo for this one: the card keeps its plain background
      var img = D.image(m.imageLength);
      if (!img) return true;
      var dpr = Math.min(window.devicePixelRatio || 1, 2);
      var w = c.clientWidth || 140, h = c.clientHeight || 90;
      c.width = w * dpr; c.height = h * dpr;
      var ctx = c.getContext('2d');
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      ctx.fillStyle = '#efebe4'; ctx.fillRect(0, 0, w, h);
      var fw = m.widthMm || 20, scale = h / (fw + 26);
      ctx.save(); ctx.translate(10, 10); ctx.scale(scale, scale);
      D.drawPreset(ctx, { preset: THUMB, fw: fw, moulding: img, outerMount: { hex: '#f6f3ec' }, innerMount: { hex: '#f6f3ec' }, glass: 'clear' }, { dpr: dpr, scale: scale });
      ctx.restore();
      return false;
    });
  }
  function buildFrames() {
    var box = $('[data-frames]');
    box.innerHTML = variants.map(function (v) {
      var m = mouldingFor(v);
      var size = m && m.widthMm ? Math.round(m.widthMm) + 'mm wide' : '';
      return '<label class="mb-frame" data-id="' + v.id + '"><input type="radio" name="vf-frame" value="' + v.id + '"' + (v.available ? '' : ' disabled') + '>' +
        '<span class="mb-frame__pics"><canvas class="mb-frame__corner" data-id="' + v.id + '" aria-hidden="true"></canvas></span>' +
        '<span class="mb-frame__name">' + esc(v.title) + '</span><span class="mb-frame__meta">' + esc(size) + '</span>' +
        '<span class="mb-diff" data-diff></span><span class="mb-frame__why">' + (v.available ? '' : 'Not available just now') + '</span></label>';
    }).join('');
    thumbs = $$('.mb-frame__corner', box);
    variants.forEach(function (v) { var m = mouldingFor(v); if (m) D.image(m.imageLength); });
    drawThumbs();
    box.addEventListener('change', function (e) {
      state.variantId = Number(e.target.value);
      T('mtm_option_chosen', { option: 'frame', choice: (variant() || {}).title });
      // The address follows the choice, as on other product pages (?variant=…), so it can be shared or bookmarked
      try { var u = new URL(location.href); u.searchParams.set('variant', state.variantId); history.replaceState(null, '', u); } catch (err) { /* old browsers */ }
      changed();
    });
    $('[data-filters]').innerHTML = FILTERS.map(function (f) { return '<button type="button" data-filter="' + f.key + '" aria-pressed="' + (f.key === 'all') + '">' + f.label + '</button>'; }).join('');
    $('[data-filters]').addEventListener('click', function (e) {
      var b = e.target.closest('[data-filter]'); if (!b) return;
      filter = b.getAttribute('data-filter');
      $$('[data-filter]').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
      refresh();
    });
  }
  function buildSwatches() {
    var box = $('[data-swatches]');
    box.innerHTML = cat.mounts.map(function (m) {
      var bg = 'background-color:' + esc(m.hex || '#fff') + ';' + (m.image ? 'background-image:url(' + esc(m.image) + ');' : '');
      return '<label class="mb-swatch" title="' + esc(m.name) + '"><input type="radio" name="vf-inner" value="' + esc(m.id) + '">' +
        '<span class="mb-swatch__chip" style="' + bg + '"></span><span class="mb-swatch__name">' + esc(m.name) + '</span></label>';
    }).join('');
    box.addEventListener('change', function (e) {
      state.innerId = e.target.value;
      T('mtm_option_chosen', { option: 'inner_mount_colour', choice: (mountById(state.innerId) || {}).name });
      changed();
    });
  }

  function refresh() {
    var f = FILTERS.find(function (x) { return x.key === filter; });
    var cur = variant();
    $$('.mb-frame', $('[data-frames]')).forEach(function (el) {
      var v = variants.find(function (x) { return String(x.id) === el.getAttribute('data-id'); });
      el.hidden = !(!f.re || f.re.test(v.title));
      var input = el.querySelector('input');
      input.checked = v.id === state.variantId;
      el.classList.toggle('is-selected', input.checked);
      el.classList.toggle('is-off', !v.available);
      // "+£6 / −£4" against the frame chosen now
      var d = el.querySelector('[data-diff]'), x = cur ? Math.round((v.price - cur.price) * 100) / 100 : 0;
      d.textContent = !cur || x === 0 ? '' : (x > 0 ? '+' : '−') + money(Math.abs(x));
    });
    $$('.mb-swatch', $('[data-swatches]')).forEach(function (el) {
      var input = el.querySelector('input'); input.checked = input.value === state.innerId;
      el.classList.toggle('is-selected', input.checked);
    });
    var inner = mountById(state.innerId);
    // The record on the turntable below wears the chosen inner mount colour
    if (inner && inner.hex) root.style.setProperty('--vf-label', inner.hex);
    $('[data-price]').textContent = cur ? money(cur.price) : '—';
    $('[data-add]').disabled = !(cur && cur.available && inner);
    $('[data-summary]').textContent = [cur && cur.title, inner && inner.name + ' inner mount'].filter(Boolean).join(' · ');
  }
  function changed() { refresh(); scheduleDraw(); }

  $('[data-add]').addEventListener('click', function () {
    var v = variant(), inner = mountById(state.innerId);
    if (!v || !inner) return;
    var btn = $('[data-add]');
    btn.disabled = true; btn.classList.add('is-busy');
    var props = {
      'Inner Mount': inner.name,
      'Outer Mount': (outerMount && outerMount.name) || 'White',
      'Mount cut-out': preset.cutOut,
      'Glass Size': preset.glassW + 'mm x ' + preset.glassH + 'mm'
    };
    fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: v.id, quantity: 1, properties: props }] })
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      window.location.href = '/cart';
    }).catch(function () {
      btn.classList.remove('is-busy'); btn.disabled = false;
      var err = $('[data-errors]');
      err.textContent = 'We couldn’t add this to your basket. Please try again, or call us on ' + PHONE + '.';
      err.hidden = false;
    });
  });

  /* ---------- The turntable starts when it comes into view ---------- */
  var story = document.querySelector('.vf-story');
  if (story) {
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { es.forEach(function (e) { story.classList.toggle('is-on', e.isIntersecting); }); }, { threshold: 0.35 }).observe(story);
    } else story.classList.add('is-on');
  }

  /* ---------- Their own sleeve in the preview ---------- */
  var upload = $('[data-art-upload]');
  if (upload) upload.addEventListener('change', function () {
    var file = upload.files && upload.files[0];
    if (!file) return;
    var reader = new FileReader();
    reader.onload = function () {
      var img = new Image();
      img.onload = function () { state.art = img; T('mtm_photo_uploaded'); scheduleDraw(); };
      img.src = reader.result;
    };
    reader.readAsDataURL(file);
  });

  /* ---------- Start: the catalogue gives the moulding photos, the mount colours and the design's size and cut-out ---------- */
  fetch(API + '/catalogue').then(function (r) { return r.json(); }).then(function (c) {
    cat = c;
    preset = (c.presets || []).find(function (p) { return p.id === PRESET; });
    if (!preset) throw new Error('no preset');
    // Only frames named like one of our mouldings are offered: to take one off this item, delete its variant in Shopify
    var matched = variants.filter(function (v) { return mouldingFor(v); });
    if (matched.length) variants = matched;
    if (!variants.some(function (v) { return v.id === state.variantId; })) state.variantId = variants[0] && variants[0].id;
    outerMount = mountByName(preset.outerMount) || mountByName('Snow White') || { name: 'White', hex: '#f7f6f2' };
    state.innerId = (mountByName(preset.defaultInner) || c.mounts[0] || {}).id;
    buildFrames(); buildSwatches();
    $('.mb-loading').hidden = true;
    T('mtm_designer_opened', { entry: 'vinyl' });
    changed();
  }).catch(function () {
    $('.mb-loading').textContent = 'The frame options couldn’t load. Please refresh, or call us on ' + PHONE + '.';
  });
})();
